import React, { createContext, PropsWithChildren, useContext } from 'react';
import { Terminal, User } from '../types/graph';

export type AppContextObject = {
    activeUnNumber: string | null,
    activeHazardClass: string | null,
    activeTerminal: Terminal | null,

    user?: User | null,
    terminals?: Terminal[] | null,

    baseUrl: string | null,
    terminalsUrl: string | null,
    emergencyCardsUrl: string | null
};

const AppContext = createContext<AppContextObject>({
    activeUnNumber: null,
    activeHazardClass: null,
    activeTerminal: null,

    baseUrl: document.getElementsByTagName('base')?.[0]?.getAttribute('href') ?? null,
    terminalsUrl: null,
    emergencyCardsUrl: null
});

export default AppContext;

export const useAppContext = () => {
    return useContext(AppContext);
}

export type AppContextProviderProps = PropsWithChildren<{
    value?: Partial<AppContextObject>
}>

export const AppContextProvider = ({ value, children }: AppContextProviderProps) => {
    const context = useAppContext();

    return <AppContext.Provider value={{ ...context, ...value }}>{children}</AppContext.Provider>;
}
